import React from "react";
import { Row, Col, Descriptions } from "antd";
import { formatDistance } from "@/utils/utils";

const ShipmentPricingInfo = ({ shipmentData }) => {
  if (!shipmentData) return null;

  const { distance, pickupZip, dropOffZip } = shipmentData;

  return (
    <Row>
      <Col span={24}>
        <Descriptions size="small" column={{ xs: 1, sm: 2, md: 3 }} style={{ marginBottom: 0 }}>
          <Descriptions.Item label="PU Zip">{pickupZip}</Descriptions.Item>
          <Descriptions.Item label="DO Zip">{dropOffZip}</Descriptions.Item>
        </Descriptions>
      </Col>
      <Col span={24}>
        <Descriptions size="small" column={{ xs: 1, sm: 2, md: 3 }} style={{ marginBottom: 0 }}>
          <Descriptions.Item label="Distance">{`${formatDistance(distance)} miles`}</Descriptions.Item>
        </Descriptions>
      </Col>
    </Row>
  );
};

export default ShipmentPricingInfo;
